// extracted by mini-css-extract-plugin
export default {"container":"Om-z","brandName":"Pm-z","productName":"Qm-z","aboveGalleryInfo":"Rm-z","belowGalleryInfo":"Sm-z","breakLongProductName":"Tm-z"};